// @flow
import map from 'lodash/map'
import * as React from 'react'
import type { QuestionChoice } from 'types/question-choice'
import TextField from 'ui/molecules/TextField'

type QuestionProps = {
  question_choices?: Array<QuestionChoice>,
  default_value?: ?string,
}

type Props = {
  choice: QuestionChoice,
  onUpdateQuestionProps: (props: QuestionProps) => void,
  questionChoices: Array<QuestionChoice>,
}

function BuilderCheckboxEditPropsContentIntegrationValue({
  choice,
  onUpdateQuestionProps,
  questionChoices,
}: Props): React.Node {
  const [value, setValue] = React.useState(choice.integration_value)
  const inputRef = React.createRef()

  React.useEffect(() => {
    if (!inputRef.current) return

    if (inputRef.current === document.activeElement) return

    if (choice.integration_value !== value) {
      setValue(choice.integration_value)
    }
  }, [choice.integration_value, inputRef, value])

  const onUpdateOptionIntegrationValue = React.useCallback(
    (optionId: string, newValue: string) => {
      onUpdateQuestionProps({
        question_choices: map(questionChoices, (choice) =>
          choice.id !== optionId
            ? choice
            : {
                ...choice,
                integration_value: newValue,
              }
        ),
      })
    },
    [onUpdateQuestionProps, questionChoices]
  )

  const onChange = React.useCallback(
    (event: SyntheticEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value
      onUpdateOptionIntegrationValue(choice.id, value)
      setValue(value)
    },
    [choice.id, onUpdateOptionIntegrationValue]
  )

  return <TextField useEvent onChange={onChange} ref={inputRef} value={value} />
}

export default BuilderCheckboxEditPropsContentIntegrationValue
